import { atom } from 'jotai';

/**
 * Whether the in-sheet Drive dialog (browser + manager for the team's uploaded
 * drive files) is open.
 */
export const driveDialogAtom = atom<boolean>(false);
